import type { Language } from "../contexts/LanguageContext";

export const navbarLabels: Record<Language, {
  home: string;
  blog: string;
  login: string;
  openMenu: string;
  goHome: string;
  language: {
    label: string;
    pt: string;
    en: string;
    searchPlaceholder: string;
    emptyMessage: string;
  };
}> = {
  pt: {
    home: "Início",
    blog: "Blog",
    login: "Entrar",
    openMenu: "Abrir menu",
    goHome: "Ir para a página inicial",
    language: {
      label: "Idioma",
      pt: "Português",
      en: "Inglês",
      searchPlaceholder: "Buscar idioma...",
      emptyMessage: "Nenhum idioma encontrado.",
    },
  },
  en: {
    home: "Home",
    blog: "Blog",
    login: "Sign in",
    openMenu: "Open menu",
    goHome: "Go to home page",
    language: {
      label: "Language",
      pt: "Portuguese",
      en: "English",
      searchPlaceholder: "Search language...",
      emptyMessage: "No languages found.",
    },
  },
};

